import type { OrderStatus } from '@api/enterprise/openapi';

export const isWorkOrderLocked = (status?: OrderStatus | string): boolean => {
  return status === 'Complete' || status === 'Invoiced';
};
